<template>
  <div id="big">
    <ul class="box">
      <li
        :class="{'number-item': !isNaN(item),'mark-item': isNaN(item)  }"
        v-for="(item,index) in orderNum"
        :key="index"
      >
        <span v-if="!isNaN(item)">
          <i ref="numberItem">0123456789</i>
        </span>
        <span v-else>{{item}}</span>
      </li>
      <div class="text">
        <span>公里</span>
      </div>
    </ul>
    <div class="polyline">
      <div class="line1">
        在线：
        <span>{{ topData.d }}</span>
      </div>
      <div class="line2">
        空车：
        <span>{{ topData.e }}</span>
      </div>
      <div class="line3">
        在途：
        <span>{{ topData.f }}</span>
      </div>
      <div class="line4">
        离线：
        <span>{{ topData.g }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    topData: {
      type: Object,
      default: function () {
        return {
          d: "-", // 在线
          e: "-", // 空车
          f: "-", //在途
          g: "-", //离线
          h: "000"
        };
      }
    }
  },
  watch: {
    topData: {
      handler (data) {
        this.toOrderNum(data.h)
      },
      deep: true
    }
  },
  data () {
    return {
      orderNum: ['0', '0', '0', ',', '0', '0', '0', ',', '9', '1', '7']
    };
  },
  mounted () {
    this.setNumberTransfrom()
  },
  methods: {
    // 设置文字滚动
    setNumberTransfrom () {
      // console.log('触发滚动')
      const numberItems = this.$refs.numberItem
      const numberArr = this.orderNum.filter(item => !isNaN(item))
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    },
    // 处理总订单数字
    toOrderNum (num) {
      num = num.toString()
      if (num.length < 9) {
        // console.log(num)
        num = '0' + num // 如未满八位数，添加"0"补位
        this.toOrderNum(num) // 递归添加"0"补位
      } else if (num.length == 9) {
        let newNum = Number(num)
        let newNumFilst = null
        let cum = []
        newNumFilst = newNum.toString()
        // 再次补零
        function PrefixZero (num, n) {
          return (Array(n).join(0) + num).slice(-n);
        }
        newNumFilst = PrefixZero(newNumFilst, 9)
        //赋值
        cum = newNumFilst.slice(0, 3) + ',' + newNumFilst.slice(3, 6) + ',' + newNumFilst.slice(6, 9)
        this.orderNum = cum.split('')
        console.log(this.orderNum)
        this.setNumberTransfrom()
      } else if (num.length > 9) {
        // 订单总量数字超过八位显示异常
        alert('订单总量数字过大，显示异常，请联系客服')
      }
    },
  }
};
</script>

<style scoped>
#big {
  width: 50%;
  height: 100%;
}
.box {
  width: 100%;
  height: 60%;
  padding-top: 4%;
  display: flex;
  position: relative;
}
.text {
  color: #8b9abb;
  font-size: 28px;
  padding-top: 50px;
  position: absolute;
  right: -50px;
  bottom: 30px;
}
.number-item {
  width: 70px;
  height: 90px;
  margin: 0 16px;
  background: url('../assets/img/bigtime/bg.png') no-repeat center center;
  background-size: 100% 100%;
  font-size: 80px;
  color: aliceblue;
  font-family: 'electronicFont';
}
.mark-item {
  font-size: 66px;
  font-family: DINAlternate-Bold;
  background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(rgba(250, 254, 255, 1)), to(rgba(47, 231, 237, 0.8)));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.number-item span {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  writing-mode: vertical-rl;
  text-orientation: upright;
  overflow: hidden;
}
.number-item span i {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translate(-50%, 0);
  transition: transform 0.5s ease-in-out;
  letter-spacing: 10px;
}
.polyline {
  display: flex;
  width: 80%;
  height: 45px;
  margin: 20px auto;
  font-family: 'DIN Alternate';
}
.polyline .line1 {
  width: 140px;
  line-height: 45px;
  background-image: url('../assets/img/bg/在线bg.png');
  background-position: center center;
  background-size: 100% 100%;
  margin: 0 auto;
  padding-left: 30px;
  font-size: 14px;
  color: #00b193;
}
.polyline .line2 {
  width: 140px;
  line-height: 45px;
  background-image: url('../assets/img/bg/空车bg.png');
  background-position: center center;
  background-size: 100% 100%;
  margin: 0 auto;
  padding-left: 30px;
  font-size: 14px;
  color: #d8be45;
}
.polyline .line3 {
  width: 140px;
  line-height: 45px;
  background-image: url('../assets/img/bg/在途bg.png');
  background-position: center center;
  background-size: 100% 100%;
  margin: 0 auto;
  padding-left: 30px;
  font-size: 14px;
  color: #25fbf4;
}
.polyline .line4 {
  width: 140px;
  line-height: 45px;
  background-image: url('../assets/img/bg/离线bg.png');
  background-position: center center;
  background-size: 100% 100%;
  margin: 0 auto;
  padding-left: 30px;
  font-size: 14px;
  color: #ff404a;
}

.polyline .line1 span,
.polyline .line2 span,
.polyline .line3 span,
.polyline .line4 span {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/bigtime.vue